<template>
  <div v-click-outside="closeSidebar">
    <b-sidebar v-model="isOpened" title="MyFigbMate">
      <div class="sidebar-content">
        <div class="tagline"><i>la webapp di WFigb</i></div>
        <b-navbar-nav class="text-left mt-3 sidebar-nav">
          <template v-for="page in pageList">
            <b-nav-item v-if="canShow(page)" :key="page.textKey" :to="page.to" exact class="ml-5">
              <b-img height="32px" width="32px" :src="require('../../assets/iconsMenu/' + page.icon + '.png')"></b-img>
              {{ $t(page.textKey) }}
            </b-nav-item>
          </template>
        </b-navbar-nav>
        <div class="sidebar-footer">
          <b-navbar-nav class="text-left">
            <template v-for="page in pageBottomList">
              <b-nav-item v-if="canShow(page)" :key="page.textKey" :to="page.to" exact class="ml-5">
                <b-icon :icon="page.icon"></b-icon>
                {{ $t(page.textKey) }}
              </b-nav-item>
            </template>
          </b-navbar-nav>
          <div class="lang-switcher ml-5">
            <b-button
              v-for="locale in availableLocales"
              :key="locale.code"
              variant="link"
              size="sm"
              :title="locale.label"
              :class="{ 'active-locale': currentLocale === locale.code }"
              @click="setLocale(locale.code)"
            >
              <b-img :src="require('../../assets/flags/' + locale.flag)" height="20px" :alt="locale.label" />
            </b-button>
          </div>
        </div>
      </div>
    </b-sidebar>
    <hamburger-menu v-show="!isOpened" v-model="isOpened" :animated="false" class="hamburger"/>
    <span v-show="!isOpened && showTournamentName" class="header-tournament-name">{{ tournamentName }}</span>
  </div>
</template>

<script>
import HamburgerMenu from './HamburgerMenu';
import {mapGetters} from "vuex";
import individualContest from "../../mixins/individualContest";

export default {
  name: 'sidebar',
  components: {HamburgerMenu},
  mixins: [individualContest],
  data() {
    return {
      isOpened: false,
      availableLocales: [
        { code: 'it', flag: 'it.svg', label: 'Italiano' },
        { code: 'en', flag: 'gb.svg', label: 'English' },
        { code: 'fr', flag: 'fr.svg', label: 'Français' },
        { code: 'es', flag: 'es.svg', label: 'Español' },
        { code: 'de', flag: 'de.svg', label: 'Deutsch' }
      ]
    };
  },
  computed: {
    ...mapGetters({
      configurations: 'webApp/configurations',
      tournamentName: 'tournament/tournamentName',
      isRunning: 'tournament/isRunning',
      playerCode: 'webApp/playerCode',
      teamRanks: 'ranks/teamRanks',
      pairRanks: 'ranks/pairRanks',
      butlerRanks: 'ranks/butlerRanks',
      playerCurrentSessionMap: 'players/playerCurrentSessionMap',
      matches: 'matches/matches',
      isTd: 'webApp/isTd',
      isVisitor: 'webApp/isVisitor',
    }),

    pageList() {
      return [
        {
          to: '/',
          icon: 'figb',
          textKey: 'pageLinks.welcome'
        },
        {
          to: 'tablesMap',
          icon: 'tavolo',
          ifEnabled: this.isTd && this.isPairContest,
          textKey: 'pageLinks.tablesMap'
        },
        {
          to: 'directorsMap',
          icon: 'arbitri',
          ifEnabled: this.canShowTdMap,
          textKey: 'pageLinks.directorsMap'
        },
        {
          to: 'sendResult',
          icon: 'inviaris',
          ifEnabled: this.canShowSendResult,
          textKey: 'pageLinks.sendResult'
        },
        {
          to: 'sendDeal',
          icon: 'sendDeal',
          ifEnabled: this.canShowSendDeal,
          textKey: 'pageLinks.sendDeal'
        },
        {
          to: 'movementGuide',
          icon: 'movim',
          ifEnabled: this.canShowMovementGuide,
          textKey: 'pageLinks.movementGuide'
        },
        {
          to: 'curriculum',
          icon: 'curriculum',
          ifEnabled: this.canShowCurriculum,
          textKey: 'pageLinks.curriculum'
        },
        {
          to: 'scoreViewer',
          icon: 'mostraris',
          ifEnabled: this.isPairContest,
          textKey: 'pageLinks.scoreViewer'
        },
        {
          to: 'teamScoreViewer',
          icon: 'confrscore',
          ifEnabled: !this.isPairContest,
          textKey: 'pageLinks.teamScoreViewer'
        },
        {
          to: 'pairRanks',
          icon: 'classcp',
          ifEnabled: Object.values(this.pairRanks?.Phases ?? {}).length > 0,
          textKey: 'pageLinks.pairRanks'
        },
        {
          to: 'teamRanks',
          icon: 'classsq',
          ifEnabled: this.teamRanks.Phases != null && Object.keys(this.teamRanks.Phases).length > 0,
          textKey: 'pageLinks.teamRanks'
        },
        {
          to: 'butlerRanks',
          icon: 'classbut',
          ifEnabled: this.butlerRanks.Phases != null && Object.keys(this.butlerRanks.Phases).length > 0,
          textKey: 'pageLinks.butlerRanks'
        },
        {
          to: 'matches',
          icon: 'incontri',
          ifEnabled: this.matches.length > 0,
          textKey: 'pageLinks.matches'
        }
      ];
    },
    pageBottomList() {
      return [
        {
          to: '/debug',
          icon: 'bug',
          ifEnabled: this.enableDebug,
          textKey: 'pageLinks.debug'
        }
      ];
    },
    canShowCurriculum() {
      return this.configurations["MostraCurriculum"] && this.isPairContest && this.playerRankId > 0;
    },
    canShowTdMap() {
      return this.isTd && this.configurations['MostraMappaTd'];
    },
    canShowMovementGuide() {
      return this.isPairContest && this.playerCurrentSessionMap.length > 0;
    },
    canShowSendResult() {
      return !this.isVisitor && this.configurations['AllowSendResults'] && this.isRunning;
    },
    showTournamentName() {
      return this.$route.path !== '/';
    },
    canShowSendDeal() {
      return !this.isVisitor && this.isPairContest && this.configurations['AllowSendResults'];
    },
    isPairContest() {
      return this.contestType !== 0;
    },
    enableDebug() {
      return ["BTR110", "DSL092"].includes(this.playerCode);
    },
    currentLocale() {
      return this.$i18n.locale;
    }
  },
  methods: {
    toggle() {
      this.isOpened = !this.isOpened;
    },
    closeSidebar() {
      this.isOpened = false;
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem('language', locale);
    },
    canShow(page) {
      if (typeof (page.ifEnabled) === 'function') {
        return page.ifEnabled();
      }
      if (typeof (page.ifEnabled) === 'boolean') {
        return page.ifEnabled;
      }

      return page.ifEnabled == null || this.configurations[page.ifEnabled];
    }
  }
};
</script>

<style scoped>
.hamburger {
  position: fixed;
  left: 1rem;
  top: 1rem;
  z-index: 1050;
  transform: translateZ(0);
  will-change: transform;
}

.header-tournament-name {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  height: 64px;
  z-index: 1049;
  transform: translateZ(0);
  will-change: transform;
  font-size: 1rem;
  font-weight: 500;
  color: #94a3b8;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  pointer-events: none;
}

>>> .b-sidebar-header strong {
  color: #fff;
  font-size: 1.1rem;
  font-weight: 700;
}

.nav-item.nav-item.nav-item a {
  color: #1e3a5f;
  font-weight: 500;
  font-size: 0.95rem;
  padding: 0.55rem 0.5rem;
  border-radius: 0.5rem;
  transition: background-color 0.15s, color 0.15s;
  display: flex;
  align-items: center;
  gap: 0.625rem;
}

.nav-item.nav-item.nav-item a:hover {
  color: #1e3a5f;
  background-color: #eef2f7;
  text-decoration: none;
}

.nav-item.nav-item.nav-item a.router-link-active {
  color: #1e3a5f;
  background-color: #e0e9f5;
  font-weight: 600;
}

.tagline {
  margin-left: 1rem;
  margin-top: 0;
  position: absolute !important;
  top: 42px;
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.78rem;
  font-style: italic;
}

.sidebar-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 0.5rem;
}

.sidebar-nav {
  flex: 1;
  overflow-y: auto;
}

.sidebar-footer {
  background: #f8fafc;
  border-top: 1px solid #e4eaf3;
  padding-top: 0.25rem;
}

.lang-switcher {
  padding: 0.5rem 0.25rem 0.25rem;
}

.active-locale img {
  outline: 2.5px solid #1e3a5f;
  border-radius: 3px;
  box-shadow: 0 1px 4px rgba(30, 58, 95, 0.2);
}

>>> .b-sidebar-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2b5080 100%);
  padding: 1.25rem 1rem 0.875rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

>>> .b-sidebar-body {
  display: flex;
  flex-direction: column;
  padding-top: 0.5rem;
}
</style>
